import { ServerClient } from 'common/utils/http/http-clients';
import { IResponseList } from 'common/models/response-list.interface';
import { IActivityLogRead } from './activity-logs.service.types';

class ActivityLogsService {
  async getAll(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
    search: string | null | undefined,
  ): Promise<IResponseList<IActivityLogRead>> {
    const res = await ServerClient.get<IResponseList<IActivityLogRead>>('activity-logs', {
      params: {
        filter,
        ...pageLimit,
        search,
        sort,
      },
    });

    return res.data;
  }
}

export const activityLogsService = new ActivityLogsService();
export default activityLogsService;
